import React from "react";
import PT from "prop-types";
import styled from "styled-components";

import { colors } from "~/src/config/vars";

const EditorListItem = ({ children, type, ...rest }) => {
    return (
        <SEditorListItem className={`${type}`}>
            <span {...rest}>{children}</span>
        </SEditorListItem>
    );
};

EditorListItem.propTypes = {
    type: PT.oneOf(["unordered", "ordered"]),
    children: PT.any,
    dangerouslySetInnerHTML: PT.any,
};

const SEditorListItem = styled.li`
    padding: 0.3em 0 0.5em 0;
    &:last-of-type {
        padding-bottom: 0;
    }
    span {
    }
    &.unordered {
        display: flex;
        &:before {
            content: "";
            width: 0.5em;
            flex: 0 0 0.5em;
            height: 0.5em;
            display: block;
            margin-right: 0.5em;
            margin-top: 0.4em;
            background-color: ${colors.violet_base};
            border-radius: 1px;
        }
    }
    &.ordered {
        list-style: decimal;
    }
`;

export default EditorListItem;
